const req = require.context('../custom_modules', true, /routes\.js$/);

let customRoutes = [];
req.keys().forEach(key => {
  const mod = req(key);
  if (Array.isArray(mod.default)) {
    customRoutes = customRoutes.concat(mod.default);
  }
});

export { customRoutes };